<template>
  <v-container>
    <div>
      <s-crud
        title="Equipo Biométrico"
        :filter="filter"
        :config="config"
        add
        edit
        no-full
        remove
        ref="crudBioEqui"
        @rowSelected="rowSelected($event)"
        @save="save($event)"
        search-input
      >
        <template v-slot:filter>
          <v-container>
            <v-row style="margin-left: 5px" justify="center">
              <v-col cols="6" sm="12" md="4">
                <s-text
                  label="Nombre del Reloj Biométrico"
                  v-model="filter.Search"
                ></s-text>
              </v-col>
              <v-col cols="6" sm="12" md="3">
                <s-text
                  label="IP del Reloj"
                  v-model="filter.BieIp"
                ></s-text>
              </v-col>
              <v-col cols="6" sm="12" md="3">
                <s-select-definition
                  label="Tipo de Conexión"
                  :def="1516"
                  v-model="filter.BieModel"
                  clearable
                  no-default
                />
              </v-col>
            </v-row>
          </v-container>
        </template>
        <template scope="props">
          <v-container>
            <v-row>
              <!-- Selector del Reloj TI (Tipo 10) -->
              <v-col cols="12" sm="12" md="6">
                <div style="padding-top:-2px;margin-top:-2px;">
                  <v-label>
                    <b>Reloj TI (Tipo 10) *</b>
                  </v-label>
                  <v-autocomplete
                    ref="BieID"
                    :items="displayClocks(props.item)"
                    item-text="CgeHostname"
                    item-value="CgeID"
                    v-model="props.item.BieID"
                    :rules="rules"
                    outlined
                    dense
                    hide-details="auto"
                    placeholder="Seleccione el reloj de TI..."
                    @change="onClockSelected($event, props.item)"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">
                          {{ item.CgeHostname }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="caption grey--text">
                          Serie: {{ item.CgeSerie }} | IP: {{ item.BieIP }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </div>
              </v-col>

              <!-- Serie del Equipo (Informativo de TI) -->
              <v-col cols="12" sm="6" md="3">
                <s-text
                  label="Serie del Reloj (TI)"
                  v-model="props.item.BieSerie"
                  disabled
                ></s-text>
              </v-col>

              <!-- IP del Equipo (Informativo, extraída de TI CgeAnydesk) -->
              <v-col cols="12" sm="6" md="3">
                <s-text
                  label="IP del Reloj (TI)"
                  v-model="props.item.BieIP"
                  disabled
                ></s-text>
              </v-col>

              <!-- Puerto IP -->
              <v-col cols="6" sm="3" md="2">
                <s-text
                  ref="BiePortIP"
                  label="Puerto IP *"
                  v-model="props.item.BiePortIP"
                  :rules="rules"
                ></s-text>
              </v-col>

              <!-- Tipo de Conexión / Protocolo -->
              <v-col cols="12" sm="6" md="4">
                <s-select-definition
                  ref="BieModel"
                  :def="1516"
                  label="Tipo de Conexión *"
                  v-model="props.item.BieModel"
                  :rules="rules"
                ></s-select-definition>
              </v-col>

              <!-- Tipo de Comunicación -->
              <v-col cols="12" sm="6" md="3">
                <s-select-definition
                  label="Tipo de Comunicación"
                  :add="$fun.isAdmin()"
                  :def="1496"
                  v-model="props.item.TypeComunication"
                ></s-select-definition>
              </v-col>

              <!-- Estado del Equipo -->
              <v-col cols="12" sm="6" md="3">
                <s-select-definition
                  label="Estado del Equipo"
                  :add="$fun.isAdmin()"
                  :def="1497"
                  v-model="props.item.BieStatus"
                ></s-select-definition>
              </v-col>

              <!-- Alcance del Reloj (General vs Por Áreas vs Contingencia) -->
              <v-col cols="12" sm="12" md="4" class="d-flex align-center pt-5">
                <v-switch
                  v-model="props.item.BieIsGeneral"
                  label="Reloj General (Para todo el personal fiscalizado)"
                  color="primary"
                  dense
                  hide-details
                ></v-switch>
              </v-col>

              <!-- Áreas Asignadas al Reloj (cuando no es general) -->
              <v-col cols="12" sm="12" md="8" v-if="!props.item.BieIsGeneral">
                <div style="padding-top:-2px;margin-top:-2px;">
                  <v-label>
                    <b>Áreas Asignadas al Reloj (Vacío = Contingencia / Manual)</b>
                  </v-label>
                  <v-autocomplete
                    ref="areaAutocomplete"
                    v-model="props.item.selectedAreas"
                    :items="areaList"
                    item-text="GenDescription"
                    item-value="GenID"
                    multiple
                    chips
                    small-chips
                    deletable-chips
                    outlined
                    dense
                    clearable
                    hide-details="auto"
                    :search-input.sync="areaSearchText"
                    placeholder="Seleccione las áreas a las que atiende este reloj..."
                    @change="clearAreaSearch"
                    @input="clearAreaSearch"
                  ></v-autocomplete>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </s-crud>
    </div>
  </v-container>
</template>

<script>
//Service
import _sBiometricEquipmentService from "@/services/HumanResource/BiometricEquipmentService";
import _sGenericService from "@/services/General/GenericService";

export default {
  name: "BiometricEquipment",
  data() {
    return {
      selected: null,
      filter: {},
      availableClocks: [],
      areaList: [],
      areaSearchText: "",

      config: {
        service: _sBiometricEquipmentService,
        model: {
          BieID: "ID",
          BieRegistrationDate: "date",
          BieModel: "int",
          SecStatus: "int",
        },

        headers: [
          { text: "ID (CgeID)", value: "BieID", width: 15 },
          { text: "Equipo Reloj", value: "BieEquipment", width: 90 },
          { text: "Serie", value: "BieSerie", width: 50 },
          { text: "IP (TI)", value: "BieIP", width: 35 },
          { text: "Puerto", value: "BiePortIP", width: 25 },
          { text: "Alcance", value: "ScopeType", width: 45 },
          { text: "Áreas Asignadas", value: "AssignedAreas", width: 85 },
          { text: "Tipo Conexión", value: "BieModelName", width: 40 },
          { text: "Comunicación", value: "TypeComunicationName", width: 40 },
          { text: "Estado", value: "BieStatusName", width: 35 },
          { text: "Fecha Registro", value: "BieRegistrationDate", width: 50 },
        ],
      },

      rules: [(value) => !!value || "El campo es obligatorio."],
    };
  },

  mounted() {
    this.loadAvailableClocks();
    this.loadAreas();
  },

  methods: {
    async loadAreas() {
      try {
        const url = _sGenericService.getUrlSearchArea();
        const res = await this.$http.post(
          url,
          {},
          {
            params: {
              TypeArea: 3,
              search: "",
              requestID: this.$fun.getUserID(),
            },
          }
        );
        if (res.status === 200) {
          this.areaList = res.data || [];
        }
      } catch (err) {
        console.error("Error al cargar lista de áreas:", err);
      }
    },

    async loadAvailableClocks(currentBieID = null) {
      try {
        const res = await _sBiometricEquipmentService.availableClocks(currentBieID);
        this.availableClocks = res.data || [];
      } catch (error) {
        console.error("Error al cargar relojes de TI:", error);
      }
    },

    displayClocks(item) {
      if (item && item.BieID) {
        const exists = this.availableClocks.some((c) => c.CgeID === item.BieID);
        if (!exists) {
          return [
            {
              CgeID: item.BieID,
              CgeHostname: item.BieEquipment || `Reloj TI #${item.BieID}`,
              CgeSerie: item.BieSerie,
              BieIP: item.BieIP,
            },
            ...this.availableClocks,
          ];
        }
      }
      return this.availableClocks;
    },

    onClockSelected(cgeId, item) {
      const clock = this.availableClocks.find((c) => c.CgeID === cgeId);
      if (clock) {
        item.BieID = clock.CgeID;
        item.BieEquipment = clock.CgeHostname;
        item.BieSerie = clock.CgeSerie;
        item.BieIP = clock.BieIP;

        if (!item.BiePortIP) {
          item.BiePortIP = "4370";
        }
        if (!item.TypeComunication) {
          item.TypeComunication = 3; // TCPIP
        }
        if (!item.BieStatus) {
          item.BieStatus = 1; // Operativo
        }
        if (!item.BieModel) {
          item.BieModel =
            clock.CgeSerie && clock.CgeSerie.startsWith("CK7") ? 1 : 2;
        }
      }
    },

    clearAreaSearch() {
      this.$nextTick(() => {
        this.areaSearchText = "";
        const comp = Array.isArray(this.$refs.areaAutocomplete)
          ? this.$refs.areaAutocomplete[0]
          : this.$refs.areaAutocomplete;
        if (comp) {
          comp.internalSearch = "";
          comp.lazySearch = "";
          if (comp.$refs && comp.$refs.input) {
            comp.$refs.input.value = "";
          }
        }
      });
    },

    async rowSelected(items) {
      this.clearAreaSearch();
      if (items && items.length > 0) {
        this.selected = items[0];
        if (this.selected.BieID) {
          try {
            const resAreas = await _sBiometricEquipmentService.getClockAreas(this.selected.BieID);
            this.$set(
              this.selected,
              "selectedAreas",
              (resAreas.data || []).map((a) => a.AreID)
            );
          } catch (e) {
            console.error("Error al cargar áreas asignadas:", e);
          }
        }
      } else {
        this.selected = null;
      }
    },

    async save(item) {
      if (!item.BieID) {
        this.$fun.alert("Por favor, seleccione un Reloj de TI.", "warning");
        return;
      }
      if (!item.BiePortIP) {
        item.BiePortIP = "4370";
      }
      if (!item.TypeComunication) {
        item.TypeComunication = 3;
      }
      if (!item.BieStatus) {
        item.BieStatus = 1;
      }
      if (!item.BieModel) {
        item.BieModel = 1;
      }

      // Asegurar SecStatus activo (1)
      item.SecStatus = 1;

      // Convertir array de áreas a cadena separada por comas
      item.AssignedAreaIDs = (item.selectedAreas || []).join(",");

      await item.save();
      await this.loadAvailableClocks();
    },
  },
};
</script>
<style scoped></style>
